const TOKEN_KEY = 'control-center-token';
const OVERSIGHT_KEY = 'oversight-token';

export const setLocalStorageToken = (token: string): void => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const getLocalStorageToken = (): string | null => {
  const value = localStorage.getItem(TOKEN_KEY);
  return value;
};

export const getLocalStorageOversightToken = (): string | null => {
  const value = localStorage.getItem(OVERSIGHT_KEY);
  return value;
};

export const removeLocalStorageToken = (): void => {
  localStorage.removeItem(TOKEN_KEY);
};
